import { IFrameMessage } from "@pexip-engage-public/plugin-events";

import { IS_SERVER } from "~/utils/utils";

export function sendMessage(message: IFrameMessage) {
  if (IS_SERVER) {
    return console.error("Trying to emit message on the server!");
  }

  if (ENV.IS_DEV) {
    console.debug("[IFRAME EVENT]", message);
  }

  if ("parentIFrame" in window) {
    window.parentIFrame?.sendMessage(message);
  }
}
